import { LoadMethodOptions, Query } from '@cubejs-client/core';

export interface ICubeRepository {
  query(
    token: string,
    data: Query,
    options?: LoadMethodOptions
  ): Promise<any[]>;
}
